<script setup lang="ts">
import type { CarouselFavorite, LrudNode } from '#build/components';

const mounted = ref(false);
onMounted(() => {
    mounted.value = true;
});

const { packages } = useAuth();
</script>
<template>
    <main class="main">
        <LrudNode orientation="vertical" class="main__content">
            <LogoTitle title="Кинотеатр" />

            <LrudNode lrudScroll defaultFocus>
                <CarouselCompilations code="y-ru_afisha_month" />
            </LrudNode>

            <LrudNode lrudScroll>
                <CarouselCompilations code="y-ru-last-chance" />
            </LrudNode>

            <LogoTitle class="mt-56" title="Прямой эфир" />

            <LrudNode lrudScroll>
                <!-- <==== FOCUS ON MOUNTED -->
                <CarouselFavorite type="channel" title="Мои каналы" />
            </LrudNode>

            <LrudNode ref="carouselFilterNode" class="mt-24" orientation="vertical" lrudScroll>
                <CarouselCompilationsFilter
                    v-if="mounted"
                    :compilations="[
                        'y_premium',
                        'y_live_page_top_20',
                        'y_live_page_movie_channels',
                        'y_live_page_entertainment',
                        'y_live_page_kids',
                        'y_live_page_educational',
                        'y_live_page_style',
                        'y_live_page_national'
                    ]"
                >
                </CarouselCompilationsFilter>
            </LrudNode>

            <LrudNode v-if="!packages?.includes('YRP')" lrudScroll>
                <CarouselCompilations code="y_3_ntv" />
            </LrudNode>
        </LrudNode>
    </main>
</template>
